import { KLineData } from "klinecharts";
import { readStyle } from "./indicatorUtils";

export const createVolumes = (settings: any) => {
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const upS = readStyle(styles, "volumeUp", "#26A69A");
  const downS = readStyle(styles, "volumeDown", "#EF5350");

  return {
    name: "volumes",
    shortName: "VOL",
    calcParams: [] as number[],
    series: "normal" as const,
    figures: [{ key: "volume", title: "Volume: ", type: "bar" }],
    styles: {
      bars: [
        {
          upColor: upS.color,
          downColor: downS.color,
          noChangeColor: "#888888",
        },
      ],
    },
    regenerateFigures: () => [
      { key: "volume", title: "Volume: ", type: "bar" },
    ],
    calc: (dataList: KLineData[]) => {
      const n = dataList.length;
      const results: Array<{ volume?: number }> = new Array(n);

      for (let i = 0; i < n; i++) {
        results[i] = { volume: dataList[i]!.volume ?? 0 };
      }

      return results;
    },
  };
};
